var exports = {
  "cover": "BandCover.module__cover___ZHRWdH",
  "hero": "BandCover.module__hero___ZHRWdH",
  "tile": "BandCover.module__tile___ZHRWdH",
  "highway": "BandCover.module__highway___ZHRWdH",
  "lane": "BandCover.module__lane___ZHRWdH",
  "green": "BandCover.module__green___ZHRWdH",
  "red": "BandCover.module__red___ZHRWdH",
  "yellow": "BandCover.module__yellow___ZHRWdH",
  "blue": "BandCover.module__blue___ZHRWdH",
  "orange": "BandCover.module__orange___ZHRWdH",
  "note": "BandCover.module__note___ZHRWdH",
  "fade": "BandCover.module__fade___ZHRWdH",
  "wordmark": "BandCover.module__wordmark___ZHRWdH",
  "wordmarkText": "BandCover.module__wordmarkText___ZHRWdH",
  "wordmarkLine": "BandCover.module__wordmarkLine___ZHRWdH",
  "block": "BandCover.module__block___ZHRWdH",
};

__webpack_require__.r(module.exports = exports);
